import React, { useCallback, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { OrgContext } from "contexts/OrgContext";

type BrevConnectTriggerProps = {
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
};

export const BrevConnectTrigger: React.FC<{
  children?: React.ReactNode;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}> = ({ children, open, onOpenChange }) => {
  const history = useHistory();
  const { activeOrgId } = useContext(OrgContext);

  const openRegisterComputePage = useCallback(() => {
    if (!activeOrgId) return;
    onOpenChange?.(false);
    history.push(`/org/${activeOrgId}/brev-connect/new`);
  }, [activeOrgId, history, onOpenChange]);

  useEffect(() => {
    if (open) openRegisterComputePage();
  }, [open, openRegisterComputePage]);

  if (!React.isValidElement<BrevConnectTriggerProps>(children)) {
    return null;
  }

  return React.cloneElement(children, {
    disabled: !activeOrgId || children.props.disabled,
    onClick: (event) => {
      children.props.onClick?.(event);
      if (!event.defaultPrevented) openRegisterComputePage();
    },
  });
};
